import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { GlobalSwitchesComponent } from '../components/global-Switches.component';
import { selectGlobalSwitchesQueryItems } from '../../../../../redux/global-iship-cloud/global-switches/selector';
import { globalSwitches } from '../../../../../redux/global-iship-cloud/global-switches/action';

const GlobalSwitch = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalSwitchesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    switches,
    setSwitches
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalSwitches.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-switches/fetch-detail`, entity: 'globalSwitches', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalSwitchId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setSwitches(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setSwitches({ ...switches, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalSwitches.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-switches`, entity: 'globalSwitches', jsonData:
        {
          "Context": {},
          Records: [
            switches
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalSwitches.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-switches`, entity: 'globalSwitches', jsonData:
        {
          "Context": {
          },
          Records: [
            switches
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalSwitchesComponent
          switches={switches}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalSwitch;